import { render, staticRenderFns } from "./ShopSettingsPassword.vue?vue&type=template&id=3c323df6&"
import script from "./ShopSettingsPassword.vue?vue&type=script&lang=js&"
export * from "./ShopSettingsPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
